import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { IClienteForm } from "../../../types/cliente";
import { removeDigitos } from "../../../utils/masks";
import { useContextSite } from "../../../context/Context";
import { useCadastrarCliente } from "../../../hooks/queries/cliente/useCadastrarCliente/useCadastrarCliente";
import { Tracking } from "../../../services/Tracking";
import { TipoClienteEnum } from "../../../enums/tipoCliente";
import { useBrowserSessionStorage } from "../../../hooks/useBrowserSessionStorage";

export const useDispatcherCustomerRegisterV2 = () => {
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();
  const { mutate: cadastrarCliente } = useCadastrarCliente();
  const [, setUuidClienteAgendamento] = useBrowserSessionStorage(
    "@uuidClienteAgendamento",
  );
  const [step, setStep] = useState<1 | 2>(1);
  const [clientForm, setClientForm] = useState<IClienteForm>(
    {} as IClienteForm,
  );

  function handleRegister(data: IClienteForm) {
    setClientForm(data);
    setStep(2);
  }

  function handleConfirm() {
    const payload: IClienteForm = {
      ...clientForm,
      tipo: TipoClienteEnum.PARTICULAR,
      cpfCnpj: removeDigitos(clientForm.cpfCnpj),
    };

    setIsLoad(true);
    cadastrarCliente(payload, {
      onSuccess: ({ data }) => {
        setUuidClienteAgendamento(data.uuid);
        toast.success("Cliente cadastrado com sucesso!");
        navigate("/agendamento");
      },
      onError: ({
        response: {
          data: { mensagem },
        },
      }: any) => {
        Tracking.error("mapa:agendamento/cadastro-cliente:cadastrar-falhou", {
          mensagem,
        });
      },
      onSettled: () => setIsLoad(false),
    });
  }

  return { handleRegister, step, setStep, clientForm, handleConfirm };
};
